export default "__VITE_ASSET__0b60dcf5__"